import JSEncrypt from 'jsencrypt'
import Encrypt from 'encryptlong'

const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCupbX1KPEc6lZmOINDFQ/t3C9yXcEqzMtPa75N/Q2tfRjlEduTq2BElFcXCUE5Jv3YMMKZDHZca0NA+E8Qi2yB/4tzz9e+yZc/xCVR8TAYSo6w4PuR/HfMV6jaOHLXnSxjkkQnQUzYTquz1P7vINDiYv3mCJey7U7JcbqB6EtwNQIDAQAB'

function encrypt(data) {
  let encryptor = new Encrypt()
  encryptor.setPublicKey(publicKey)
  let result = encryptor.encryptLong(data)

  return result
}
function decrypt(data) {
  let encryptor = new Encrypt()
  encryptor.setPrivateKey(publicKey)
  let result = encryptor.encryptLong(data)
  return result
}

export default{
  encrypt,
  decrypt
}
